import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Api from "../../Api";
import { ListPageUrl, NewPageUrlModalForm } from "../../component";

const PageUrl = () => {
  interface PageUrl {
    pageURLId: number;
    description: string;
    url: string;
  }

  interface StateType {
    stateName: string;
    stateId: number;
  }

  interface CategoryType {
    categoryName: string;
    categoryId: number;
  }

  const initialState = {
    stateId: null,
    categoryId: null,
  };

  const [pageUrls, setPageUrls] = useState<PageUrl[]>([]);
  const [findOptions, setFindOptions] = useState(initialState);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [listCount, setListCount] = useState(0);
  const [selectedRecord, setSelectedRecord] = useState({
    pageURLId: 0,
    description: "",
    url: "",
  });
  const [isEdit, setIsEdit] = useState(false);

  const resetFindOptions = () => setFindOptions(initialState);
  const api = Api();

  const pageUrlValidationSchema = Yup.object().shape({
    url: Yup.string().required("Url is required"),
    description: Yup.string().required("Description is required"),
  });

  const handleFindMapping = (findOptions: any) => setFindOptions(findOptions);
  const handleCreateOrUpdatePageUrl = (payload: {
    pageURLId?: number;
    description: string;
    url: string;
  }) => {
    if(isEdit){
      api.pageUrl
      .updatePageURL(payload)
      .then((response: any) => {
        toast.success(response.message);
        searchPageURL({ ...findOptions, pageIndex, pageSize });
      });
    }else{
      api.pageUrl
      .createPageURL(payload)
      .then((response: any) => {
        toast.success(response.message);
        searchPageURL({ ...findOptions, pageIndex, pageSize });
      });
    }

  };

  const onCloseHandler = () => {
    setIsEdit(false);
  };

  const searchPageURL = (findOptions: any) => {
    api.pageUrl.searchPageURL(findOptions).then((response: any) => {
      if (response) {
        setListCount(response.pageURLListCount);
        setPageUrls(response.pageURLList);
        if(response.pageURLListPageIndex>1 && response.pageURLListPageSize === 0){
          setPageIndex(pageIndex-1)
        }
      }
    });
  };

  const handelDelete = (pageURLId: number) => {
    api.pageUrl.deletePageURL(pageURLId).then((response: any) => {
      if (response) {
        toast.success(response.message);
        searchPageURL({ ...findOptions, pageIndex, pageSize });
      }
    });
  };

  const onChangePageIndex = (pageNumber: number) =>
    setPageIndex(pageNumber - 1);
  const onChangePageSize = (pageSize: number) => setPageSize(pageSize);

  
  const editHandler = (pageUrl: PageUrl)=>{
    setSelectedRecord({
      pageURLId: pageUrl.pageURLId,
      description: pageUrl.description,
      url: pageUrl.url,
    });
    setIsEdit(true)
  }

  useEffect(() => {
    searchPageURL({ ...findOptions, pageIndex, pageSize });
  }, [findOptions, pageIndex, pageSize]);

  return (
    <div className="w-100">
      <div className="float-end mx-2">
        <NewPageUrlModalForm
          onCreateNewUrl={handleCreateOrUpdatePageUrl}
          pageUrlValidationSchema={pageUrlValidationSchema}
          pageUrlData={selectedRecord}
          isEdit={isEdit}
          onClose={() => onCloseHandler()}
        />
      </div>

      <ListPageUrl
        pageUrlList={pageUrls}
        resetFindOptions={resetFindOptions}
        findOptions={findOptions}
        handleFindMapping={handleFindMapping}
        handelDelete={(pageURLId: number) => handelDelete(pageURLId)}
        totalItemCount={listCount}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onChangePageIndex={(pageNumber: number) =>
          onChangePageIndex(pageNumber)
        }
        onChangePageSize={onChangePageSize}
        handelEdit={(pageUrl: PageUrl)=>editHandler(pageUrl)}
      />
    </div>
  );
};

export default PageUrl;
